// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"cygnus_cardBody__uVOnV"};